




import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

import * as echarts from "echarts";

@Component
export default class ElEchart extends Vue {
	echartIns: any = null;
	echartTipAble: boolean = false;
	domWidth: number = 0;
	domHeight: number = 0;

	mounted() {
		const rect: any = this.$el.getBoundingClientRect();
		this.domWidth = rect.width;
		this.domHeight = rect.height;
		this.echartIns = echarts.init(this.$el);
		this.echartIns.on("mouseover", this.onOverHandler);
		this.echartIns.on("globalout", this.onOutHandler);

		this.echartIns.on("click", this.changeHandler);
		this.echartIns.on("legendselectchanged", this.changeHandler);

		window.addEventListener("resize", this.onResizeHandler);
	}
	beforeDestroy() {
		this.echartIns.off("mouseover", this.onOverHandler);
		this.echartIns.off("globalout", this.onOutHandler);
		this.echartIns.off("click", this.changeHandler);
		this.echartIns.off("legendselectchanged", this.changeHandler);
		this.echartIns.clear();
		this.echartIns.dispose();
		window.removeEventListener("resize", this.onResizeHandler);
	}
	setOption(option: Object, notMerge?: boolean, lazyUpdate?: boolean) {
		this.echartIns.setOption(option, notMerge, lazyUpdate);
		this.echartIns.resize();
	}
	clear() {
		this.echartIns.clear();
	}
	resize() {
		this.echartIns.resize();
	}
	dispatchAction(payload: any) {
		this.echartIns.dispatchAction(payload);
	}
	onResizeHandler(e: Event) {
		const rect: any = this.$el.getBoundingClientRect();
		if (this.domWidth != rect.width || this.domHeight != rect.height) {
			this.domWidth = rect.width;
			this.domHeight = rect.height;
		}
		this.resize();
	}
	onOverHandler() {
		this.echartTipAble = true;
	}
	onOutHandler() {
		this.echartTipAble = false;
	}
	changeHandler(payload: any) {
		this.$emit("change", payload);
	}
}
